import tooltipNavnetryk from '../../../../assets/cls-dk/products/pdp-tooltips/tryk-navn-logo.jpg';
import tooltipSpecialTekst from '../../../../assets/cls-dk/products/pdp-tooltips/example_special-tekst.jpg';
import tooltipFlag from '../../../../assets/cls-dk/products/pdp-tooltips/example_flag_print.jpg';
import tooltipBogstav from '../../../../assets/cls-dk/products/pdp-tooltips/example_klassens_bogstav.jpg';
import tooltipBrysttryk from '../../../../assets/cls-dk/products/pdp-tooltips/example_lille_brysttryk.jpg';
import tooltipRygtryk from '../../../../assets/cls-dk/products/pdp-tooltips/rygtryk_a4.jpg';

export const ADDON_TOOLTIPS = {
  navnetryk: {
    title: 'Eksempel navnetryk',
    image: tooltipNavnetryk,
    description: 'Her har du mulighed for at få navnetryk. Der kan max. indtastes 16 tegn inkl. mellemrum. Navnet bliver placeret på det ene bryst. Bemærk, specielle tegn som kinesiske m.m er ikke muligt.\n\n(Tjek om dit navn er stavet korrekt - både her og på den tegning, som laves til rygtryk)',
  },
  specialTekst: {
    title: 'Eksempel speciel tekst',
    image: tooltipSpecialTekst,
    description: 'F.eks. navn på Instagram eller kælenavn. Teksten bliver trykt på ærmet. Max 16 tegn inkl. mellemrum.',
  },
  flag: {
    title: 'Eksempel flag',
    image: tooltipFlag,
    description: 'Vælg et flag der bliver trykt på ærmet af din trøje. Flaget er ca. 3×2 cm.',
  },
  klassensBogstav: {
    title: 'Eksempel klassens bogstav',
    image: tooltipBogstav,
    description: 'Klassens bogstav bliver broderet på ærmet. Vælg det bogstav der passer til din klasse.',
  },
  lilleBrysttryk: {
    title: 'Eksempel lille brysttryk',
    image: tooltipBrysttryk,
    description: 'Skolens logo eller eget logo (Tryk) bliver placeret på brystet. Bemærk, dette er et tryk — ikke broderi.',
  },
  rygtryk: {
    title: 'Eksempel rygtryk',
    image: tooltipRygtryk,
    description: 'Et unikt design til din klasse, som bliver trykt på ryggen af trøjen. Du kan vælge mellem A4 og A3 format.',
  },
};
